module.exports = "Zadejte <strong>parcelní číslo(a) oceňovaného pozemku</strong>. Zadávejte ve formátu např. &bdquo;432/1, 543/2, 654/3&ldquo;.\n";